let newsSidebar = jQuery('.news__sidebar')

jQuery(window).on('resize', _.debounce(function () {

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }

}, 1000))

jQuery(document).ready(function () {

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }

    if ( jQuery( '.featured__sidebar__clock iframe, .drawer__clock iframe' ).length > 0 )
        jQuery( '.featured__sidebar__clock iframe, .drawer__clock iframe' ).attr( 'src', 'https://static.rolex.com/clocks/2018/Dubaidutyfree1_HTML_300x90/rolex.html' )
})
